import { render, staticRenderFns } from "./DetailOrderPacking.vue?vue&type=template&id=1c219e50&scoped=true&"
import script from "./DetailOrderPacking.vue?vue&type=script&lang=js&"
export * from "./DetailOrderPacking.vue?vue&type=script&lang=js&"
import style0 from "./DetailOrderPacking.vue?vue&type=style&index=0&id=1c219e50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c219e50",
  null
  
)

export default component.exports